import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  StorylinePublisherSettingsLoadFulfilledAction,
  StorylinePublisherSettingsLoadPendingAction,
  StorylinePublisherSettingsLoadRejectedAction,
} from '../../domains/storylinePublisherSettings/actions.types';

import { StorylinePublisherSettingsLifecycle } from './types';

export type StorylinePublisherSettingsAction =
  | StorylinePublisherSettingsLoadPendingAction
  | StorylinePublisherSettingsLoadRejectedAction
  | StorylinePublisherSettingsLoadFulfilledAction;

const initialState: StorylinePublisherSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<StorylinePublisherSettingsLifecycle, StorylinePublisherSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'STORYLINE_PUBLISHER_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'STORYLINE_PUBLISHER_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'STORYLINE_PUBLISHER_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
